import { render } from "./chatHistory.vue?vue&type=template&id=bc6a8276"
import script from "./chatHistory.vue?vue&type=script&lang=js"
export * from "./chatHistory.vue?vue&type=script&lang=js"

import "./chatHistory.vue?vue&type=style&index=0&id=bc6a8276&lang=scss"
script.render = render

export default script